
const digest = '041c464407101a52082a29bbe2166b16c3fbd11217848a4dad02570ce7bb56e7';
const css = `._codeSnippet_1uny7_1 {
  font-family: monospace;
  color: #d14;
  border: 1px solid #e1e1e8;
  padding: 0 4px;
  margin: 0;
  border-radius: 3px;
  background-color: #f7f7f9;
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"codeSnippet":"_codeSnippet_1uny7_1"};
export { css, digest };
  